/**
 * Get the download URL for a file in a content.
 */
export function getFileBlobDownloadURL(
    hiveEndpoint: string,
    contentId: string,
    file: { blobId: string; name: string }
): string {
    const url = new URL(`/content/${contentId}/blobs/${file.blobId}/${file.name}`, hiveEndpoint);
    return url.toString();
}
